<template>
  <div class="flex surg-actions-container">
    <a
      v-show="surgStartDate && surgBeforeToday"
      class="head-link-blue flex"
      href="javascript:void(0);"
      @click="$emit('cancelSurg', true)"
      style="margin-right: 0;"
    >
      <img class="scheduling-svg" src="/assets/img/svg/scheduling.svg" alt="" />
      שיבוץ מחדש
    </a>
    <a
      v-show="surgBeforeToday"
      class="head-link-blue flex"
      href="javascript:void(0);"
      @click="$emit('cancelSurg', false)"
    >
      <img src="/assets/img/svg/trash.svg" alt="" /> מחיקת ניתוח
    </a>
    <a
      v-show="surgBeforeToday"
      class="head-link-blue flex"
      href="javascript:void(0);"
      @click="$emit('onEdit')"
    >
      <img src="/assets/img/svg/ic-pen-blue.svg" alt="" />עריכת ניתוח
    </a>
    <a
      class="head-link-blue flex"
      href="javascript:void(0);"
      @click="$emit('addDirectDocs')"
    >
      <img src="/assets/img/svg/file-doc-blue.svg" alt="" />הוספת מסמכים
    </a>
    <!-- <router-link
      class="head-link-blue flex"
      :to="'/surg-special-approval/' + $route.params.id"
    >
      <img src="/assets/img/svg/file-doc-blue.svg" alt="" />הגשה לוועדת חריגים
    </router-link> -->
  </div>
</template>

<script>
export default {
  name: "ApproveActions",
  props: ["surgStartDate", "surgBeforeToday"]
};
</script>
